<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="会员关怀管理"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="getDataFunc"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
          <el-form-item label="会员姓名">
            <el-input v-model="params.PersonName" placeholder="请输入会员姓名" clearable />
          </el-form-item>
          
         
         

        </template>
        <template slot="table">
          <el-table-column prop="PersonName" label="会员姓名" align="center" width="60" />
          <el-table-column prop="InfoType" label="推送信息类型" />
          <el-table-column prop="SendTime" label="最近推送时间" />
         
          
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
       // api: require("@/api/person/persongrade").default,
        params: {
         PersonName: "",
          InfoType: "",
 
        },
      };
    },
    methods: {

    getDataFunc(params) {
      return new Promise((resolve,reject) => {
        resolve({ Data: [{PersonName:"李东海",InfoType:"生日祝福",SendTime:"2024-07-15 10:00:00"},{PersonName:"王天一",InfoType:"生日祝福",SendTime:"2024-07-18 10:00:00"},{PersonName:"蔡先生",InfoType:"生日祝福",SendTime:"2024-08-11 11:03:10"}]});
      })
    },
     
    },
  };
  </script>